import { useMutation } from "react-query";
import { EditarConsumoForm } from "../typings/index";
import http from "infra/http";

function useSaveConsumo(id: string) {
  return useMutation(
    (data: EditarConsumoForm) => {
      return http.put(`/v1/consumo/${id}`, data);
    },
    { retry: false }
  );
}

export default useSaveConsumo;
